module.exports = __webpack_public_path__ + "img/19.a5e38821.png";